import React, { useState } from 'react';
import Sidebar from '../Sidebar';
import Header from '../Header';
import UserPanel from './userPanel';

const UserPanelLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [openMenus, setOpenMenus] = useState({
    competitorResearch: false,
    messages: false,
    support: false,
    settings: false
  });
  const [notifications, setNotifications] = useState([
    { id: 1, type: 'success', title: 'User account updated', message: 'John Doe profile has been updated successfully', time: '2 min ago', unread: true },
    { id: 2, type: 'warning', title: 'User limit reached', message: 'User "Premium Plan" has reached 90% of limits', time: '1 hour ago', unread: true },
    { id: 3, type: 'info', title: 'User report ready', message: 'Monthly user activity report is ready to view', time: '3 hours ago', unread: false },
    { id: 4, type: 'success', title: 'New user registered', message: 'New user registered with Premium plan', time: '5 hours ago', unread: false }
  ]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const [currentUser] = useState({
    name: 'Mars Admin',
    email: 'mars.mediacle@gmail.com',
    plan: 'Administrator',
    avatar: 'MA',
    initials: 'MA'
  });

  const [dashboardStats] = useState({
    totalUsers: 0,
    activeUsers: 0,
    pendingUsers: 0,
    inactiveUsers: 0
  });

  const toggleMenu = (menuKey) => {
    setOpenMenus(prev => ({
      ...prev,
      [menuKey]: !prev[menuKey]
    }));
  };

  return (
    <div className="min-h-screen transition-all duration-300 bg-gray-50 dark:bg-slate-950 text-sm">
      {/* Sidebar Component */}
      <Sidebar
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
        openMenus={openMenus}
        toggleMenu={toggleMenu}
      />

      {/* Main Content Area */}
      <div className={`transition-all duration-300 ${sidebarCollapsed ? 'ml-16' : 'ml-64'}`}>
        {/* Header Component */}
        <Header
          sidebarCollapsed={sidebarCollapsed}
          setSidebarCollapsed={setSidebarCollapsed}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          notifications={notifications}
          setNotifications={setNotifications}
          showNotifications={showNotifications}
          setShowNotifications={setShowNotifications}
          showProfileDropdown={showProfileDropdown}
          setShowProfileDropdown={setShowProfileDropdown}
          currentUser={currentUser}
        />

        {/* User Panel Component */}
        <UserPanel
          currentUser={currentUser}
          dashboardStats={dashboardStats}
        />
      </div>
    </div>
  );
};

export default UserPanelLayout;